import React from 'react';
import styled from 'styled-components';
import { FilterType } from '../FilterData';

interface Props {
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function SelectedOption({ filters, setFilters }: Props) {
  const foramtDateWithDot = (value: string) => {
    return `${value.replaceAll('-', '.')}`;
  };

  return (
    <Container>
      {(filters.appraisalPrice.min !== '' ||
        filters.appraisalPrice.max !== '') && (
        <Chip>
          감정가격
          <Option>
            {filters.appraisalPrice.min !== ''
              ? `${Number(filters.appraisalPrice.min).toLocaleString()}만원`
              : ''}{' '}
            ~{' '}
            {filters.appraisalPrice.max !== ''
              ? `${Number(filters.appraisalPrice.max).toLocaleString()}만원`
              : ''}
          </Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                appraisalPrice: { min: '', max: '' },
              })
            }
          />
        </Chip>
      )}

      {(filters.minPrice.min !== '' || filters.minPrice.max !== '') && (
        <Chip>
          최저가격
          <Option>
            {filters.minPrice.min !== ''
              ? `${Number(filters.minPrice.min).toLocaleString()}만원`
              : ''}{' '}
            ~{' '}
            {filters.minPrice.max !== ''
              ? `${Number(filters.minPrice.max).toLocaleString()}만원`
              : ''}
          </Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                minPrice: { min: '', max: '' },
              })
            }
          />
        </Chip>
      )}

      {(filters.saleDate.start !== '' || filters.saleDate.end !== '') && (
        <Chip>
          매각기일
          <Option>
            {foramtDateWithDot(filters.saleDate.start)} ~{' '}
            {foramtDateWithDot(filters.saleDate.end)}
          </Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                saleDate: { start: '', end: '' },
              })
            }
          />
        </Chip>
      )}

      {(filters.approvalDate.start !== '' ||
        filters.approvalDate.end !== '') && (
        <Chip>
          사용승인
          <Option>
            {foramtDateWithDot(filters.approvalDate.start)} ~{' '}
            {foramtDateWithDot(filters.approvalDate.end)}
          </Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                approvalDate: { start: '', end: '' },
              })
            }
          />
        </Chip>
      )}

      {(filters.buildingArea.min !== '' || filters.buildingArea.max !== '') && (
        <Chip>
          건물면적
          <Option>
            {filters.buildingArea.min && `${filters.buildingArea.min}m²`} ~{' '}
            {filters.buildingArea.max && `${filters.buildingArea.max}m²`}
          </Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                buildingArea: { min: '', max: '' },
              })
            }
          />
        </Chip>
      )}

      {(filters.landArea.min !== '' || filters.landArea.max !== '') && (
        <Chip>
          토지면적
          <Option>
            {filters.landArea.min && `${filters.landArea.min}m²`} ~{' '}
            {filters.landArea.max && `${filters.landArea.max}m²`}
          </Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                landArea: { min: '', max: '' },
              })
            }
          />
        </Chip>
      )}

      {filters.bidno !== '' && (
        <Chip>
          유찰횟수
          <Option>{filters.bidno}회</Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                bidno: '',
              })
            }
          />
        </Chip>
      )}

      {filters.useArea.length !== 0 && (
        <Chip>
          용도지역
          <Option>
            {filters.useArea.length > 1
              ? `${filters.useArea[0]} 외 +${filters.useArea.length - 1}`
              : `${filters.useArea[0]}`}
          </Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                useArea: [],
              })
            }
          />
        </Chip>
      )}

      {filters.specialItemCondition.length !== 0 && (
        <Chip>
          특수조건
          <Option>
            {filters.specialItemCondition.length > 1
              ? `${filters.specialItemCondition[0]} 외 +${filters.specialItemCondition.length - 1}`
              : `${filters.specialItemCondition[0]}`}
          </Option>
          <img
            src="/assets/images/close/close-gray.svg"
            alt=""
            onClick={() =>
              setFilters({
                ...filters,
                specialItemCondition: [],
              })
            }
          />
        </Chip>
      )}
    </Container>
  );
}

export default SelectedOption;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

const Chip = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  gap: 4px;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
  background: #70737c0d;

  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const Option = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;
